
'use strict'
import axios from 'axios'
// import qs from 'qs'
import ES6Promise from 'es6-promise'
import store from '../provider/store.provider.js'
import appRouters from '../../router/router.js'
// import babelpolyfill from 'babel-polyfill' // [ext] fix ie9 promise bug??
ES6Promise.polyfill() // [ext] fix ie9 promise bug

// [ext] axios request interceptors
axios.interceptors.request.use(
  config => {
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    return config
  }
)

// [ext] axios response interceptors
axios.interceptors.response.use(
  res => {
    return res
  },
  err => {
    if (err.response) {
      switch (err.response.status) {
        case 403:
          store.dispatch('USER_LOGOUT_ACTION').then(() => {
            appRouters.replace({
              path: '/login',
              query: {
                redirect: appRouters.currentRoute.fullPath
              }
            })
          })
          break
      }
      return Promise.reject(err.response)
    } else if (err.message && err.message.indexOf('Network Error') > -1) {
      // If the error occurs on request(401), it would be handled and cleaned by axios,
      // and only Network Error is returned( response is null)
      // store.dispatch('USER_LOGOUT_ACTION').then(() => {
      //   appRouters.replace({
      //     path: '/login',
      //     query: {
      //       redirect: appRouters.currentRoute.fullPath
      //     }
      //   })
      // })
      return Promise.reject(err)
    }
  })

const http = {}
http.timeout = 60000 // 60s 1min

http.get = function (url, params, needToken = true) {
  let config = {
    method: 'GET',
    url: url,
    params: params, // params:{ key : value}
    timeout: this.timeout,
    headers: {
      'Content-Type': 'application/xxxx-form; charset=UTF-8'
    },
    responseType: 'json'
  }
  if (needToken && store.state.login.userInfo.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.login.userInfo.token
  }
  return axios(config)
}

http.post = function (url, obj, needToken = true) {
  let config = {
    method: 'POST',
    url: url,
    data: JSON.stringify(obj), // change obj to qs
    timeout: this.timeout,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    responseType: 'json'
  }
  if (needToken && store.state.login.userInfo.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.login.userInfo.token
  }
  return axios(config)
}

http.put = function (url, obj, needToken = true) {
  let config = {
    method: 'PUT',
    url: url,
    data: JSON.stringify(obj), // change obj to json
    timeout: this.timeout,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    responseType: 'json'
  }
  if (needToken && store.state.login.userInfo.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.login.userInfo.token
  }
  return axios(config)
}

http.delete = function (url, obj, needToken = true) {
  let config = {
    method: 'DELETE',
    url: url,
    data: JSON.stringify(obj), // change obj to json
    timeout: this.timeout,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
      // 'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'json'
  }
  if (needToken && store.state.login.userInfo.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.login.userInfo.token
  }
  return axios(config)
}

http.upload = function (url, obj, needToken = true) {
  let formData = new FormData()
  for (let key in obj) {
    formData.append(key, obj[key])
  }
  let config = {
    method: 'POST',
    url: url,
    data: formData,
    timeout: this.timeout,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'json'
  }
  if (needToken && store.state.login.userInfo.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.login.userInfo.token
  }
  return axios(config)
}

// [totest]
http.downLoad = function (url, fileName) {
  let config = {
    method: 'GET',
    url: url,
    headers: {
      'x-filename': fileName
    },
    responseType: 'arraybuffer'
  }
  return axios(config).then(function (res) {
    let blob = new Blob([res.data], {
      type: 'application/octet-stream'
    })
    let result = false

    let msSaveBlobHandler = navigator.msSaveBlob
    let saveBlobHandler = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob
    let urlCreateHandler = window.URL || window.webkitURL || window.mozURL || window.msURL

    // ms save blob
    if (!result && msSaveBlobHandler) {
      msSaveBlobHandler(blob, fileName)
      result = true
    } else if (!result && saveBlobHandler) { // wekit moz other save blob
      saveBlobHandler(blob, fileName)
      result = true
    } else if (!result && urlCreateHandler) { // mock link click
      let link = document.createElement('a')
      var event = document.createEvent('HTMLEvents')
      event.initEvent('click', false, false) // [ext] fix ff issue
      link.download = fileName
      link.href = urlCreateHandler.createObjectURL(blob)
      link.dispatchEvent(event)
      result = true
    } else if (!result && urlCreateHandler) { // mock window location
      let fileBase64 = urlCreateHandler.createObjectURL(blob)
      window.location = fileBase64
      result = true
    } else if (result) {
      urlCreateHandler.revokeObjectURL(blob) // [ext] release object url
      /* eslint-disable */
      resolve(true)
    } else {
      /* eslint-disable */
      resolve(false)
    }
  })
}

export default http



// WEBPACK FOOTER //
// ./src/common/plugins/http.js